import React, { FC } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import AuthenticationProvider from '@/components/provider/AuthenticationProvider';
import UserCurrentProvider from '@/components/provider/UserCurrentProvider';
import RootEditProvider from '@/components/provider/RootEditProvider/RootEditProvider';
import Shell from '@/components/edifice/Shell/Shell';

type BaseProps = Record<string, never>;

const Base: FC<BaseProps> = () => {
    return (
        <HelmetProvider>
            <AuthenticationProvider>
                <UserCurrentProvider>
                    <RootEditProvider>
                        <DndProvider backend={HTML5Backend}>
                            <Shell />
                        </DndProvider>
                    </RootEditProvider>
                </UserCurrentProvider>
            </AuthenticationProvider>
        </HelmetProvider>
    );
};

export default Base;
